export default __webpack_public_path__ + "static/media/gaara.31448db5.png";